import { render, staticRenderFns } from "./BuscarCaixasGoogleMaps.vue?vue&type=template&id=37adfae2&scoped=true&"
import script from "./BuscarCaixasGoogleMaps.vue?vue&type=script&lang=js&"
export * from "./BuscarCaixasGoogleMaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37adfae2",
  null
  
)

export default component.exports